import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import React, { useCallback } from 'react';
import { RouteE } from 'src/constants/pages.constants';
import { StyledWrapper } from 'src/features/common/explore/containers/collections-search-container/styles';
import { useProfile } from 'src/features/common/profile/hooks/profile.hooks';
import { usePublicProfile } from 'src/features/common/profile/hooks/public-profile.hooks';
import { Button } from 'src/ui/common/atoms/button';
import { Spacing } from 'src/ui/common/atoms/spacing';
import { ExploreSearch } from '../../components/explore-search/explore-search';
import { useFilters, useSetFilters } from '../../hooks/use-explore-collections';

export const CollectionsSearchContainer = () => {
    const router = useRouter();
    const { t } = useTranslation(['actions']);
    const profile = useProfile();
    const publicProfile = usePublicProfile();
    const filters = useFilters();
    const setFilters = useSetFilters();
    const userLogin = profile?.user?.login;
    const isProfileOwner = userLogin && publicProfile && publicProfile.login === userLogin;

    const openCreateCollectionPage = useCallback(() => {
        router.push(RouteE.COLLECTION_CREATE);
    }, [router]);

    return (
        <Spacing margin="0 0 20px">
            <StyledWrapper>
                <ExploreSearch filters={filters} setFilters={setFilters} />
                {!!isProfileOwner && (
                    <Spacing margin="0 0 0 10px">
                        <Button onClick={openCreateCollectionPage} variant="white">
                            {t('misc.createCollection')}
                        </Button>
                    </Spacing>
                )}
            </StyledWrapper>
        </Spacing>
    );
};
